import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { EditMailboxPinComponent } from './containers/edit-mailbox-pin.component';
import { EditMailboxPinEffects } from './state/edit-mailbox-pin.effects';
import * as fromEditMailboxPin from './state/edit-mailbox-pin.reducer';
import { EditMailboxPinViewComponent } from './views/edit-mailbox-pin-view.component';
@NgModule({
   declarations: [EditMailboxPinComponent, EditMailboxPinViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      EntitySelectModule,
      LcsDatepickerModule,
      StoreModule.forFeature(fromEditMailboxPin.editMailboxPinFeatureKey, fromEditMailboxPin.reducer),
      EffectsModule.forFeature([EditMailboxPinEffects]),
   ],
})
export class EditMailboxPinModule {}
